import React from "react";
import { Box, Typography } from "@mui/material";
import OcCurrency from "oc/components/currency/currency";

interface MyCafeteriSubaccountsTableProps {
  label: string;
  value: number;
}

export const MyCafeteriSubaccountsTable: React.FC<
  MyCafeteriSubaccountsTableProps
> = ({ label, value }) => {
  return (
    <Box display="flex" flexDirection="row">
      <Box
        flexGrow={1}
        borderBottom="1px solid #5E6366"
        paddingTop="10px"
        paddingBottom="10px"
      >
        <Typography variant="body1">{label}</Typography>
      </Box>
      <Box
        width="85px"
        textAlign="right"
        borderBottom="1px solid #5E6366"
        paddingTop="10px"
        paddingBottom="10px"
      >
        <Typography variant="body1">{OcCurrency({ value: value })}</Typography>
      </Box>
    </Box>
  );
};

export default MyCafeteriSubaccountsTable;
